import Vue from 'vue'

export class LoaderHelper {
  constructor(private vue: Vue) {}

  public isLoading(loader = 'global-loader') {
    return this.vue.$wait.is(loader)
  }

  public isntLoading(loader = 'global-helper') {
    return !this.isLoading(loader)
  }

  public promiseLoading$(promise: Promise<unknown>, loader: string) {
    this.startLoading(loader)

    return promise.then(this.stopLoading$(loader))
  }

  public startLoading(loader = 'global-loader') {
    this.vue.$wait.start(loader)
  }

  public startLoading$(loader = 'global-loader') {
    return () => this.vue.$wait.end(loader)
  }

  public stopLoading(loader = 'global-loader') {
    this.vue.$wait.end(loader)
  }

  public stopLoading$(loader: string) {
    return () => this.stopLoading(loader)
  }
}
